import React, { ReactNode, Suspense } from 'react';
import FullLoading from '@/components/molecule/FullLoading';

interface RootSuspenseProps {
  children: ReactNode;
}

const RootSuspense = ({ children }: RootSuspenseProps) => {
  return <Suspense fallback={<FullLoading />}>{children}</Suspense>;
};

export default RootSuspense;
